import httpService from '@/core/http-service'
import _ from 'lodash'

const state = {
  favoriteVehicles: null,
  visitedVehicles: null
}

const mutations = {
  remove_favorite_vehicle(state, payload) {
    state.favoriteVehicles = state.favoriteVehicles.filter((favorite) => {
      return favorite.itemId !== payload
    })
  },
  add_favorite_vehicle(state, payload) {
    if (Array.isArray(payload)) {
      state.favoriteVehicles = payload
    } else {
      if (state.favoriteVehicles === null) {
        state.favoriteVehicles = []
      }

      state.favoriteVehicles.push(payload)
    }
  },
  add_visited_vehicle(state, payload) {
    if (payload.length) {
      state.visitedVehicles = payload
    } else {
      if (state.visitedVehicles === null) {
        state.visitedVehicles = []
      }

      const filteredVehicles = state.visitedVehicles.filter((v) => {
        return v.itemId !== payload.itemId
      })

      filteredVehicles.push(payload)
      state.visitedVehicles = filteredVehicles
    }
  },
  reset_visited_vehicles(state) {
    state.visitedVehicles = null
  }
}

const actions = {
  getFavoriteVehicles({ commit }) {
    return httpService.get('vehicle/favourites').then(({ data }) => {
      commit('add_favorite_vehicle', data)
    })
  },
  addFavoriteVehicle({ commit }, payload) {
    return httpService.put(`vehicle/favourites/${payload}`).then(({ data }) => {
      commit('add_favorite_vehicle', data)
    })
  },
  deleteFavoriteVehicle({ commit }, payload) {
    return httpService.delete(`vehicle/favourites/${payload}`).then(() => {
      commit('remove_favorite_vehicle', payload)
    })
  },
  addAuthenticatedVehicleVisit({ commit }, payload) {
    if (payload.userId !== undefined) {
      let vehicles = JSON.parse(localStorage.getItem(`visited-vehicles-${payload.userId}`))

      if (vehicles === null) {
        vehicles = []
      }

      if (vehicles.length > 0) {
        vehicles = vehicles.filter((v) => {
          return v.itemId !== payload.vehicle.itemId
        })
        vehicles.push(payload.vehicle)
      } else {
        vehicles.push(payload.vehicle)
      }

      localStorage.setItem(`visited-vehicles-${payload.userId}`, JSON.stringify(vehicles))

      commit('add_visited_vehicle', payload.vehicle)
    }
  },
  addAnonymousVehicleVisit({ commit }, vehicle) {
    if (vehicle !== undefined) {
      let vehicles = JSON.parse(sessionStorage.getItem('visited-vehicles-anonymous'))

      if (vehicles === null) {
        vehicles = []
      }

      if (vehicles.length > 0) {
        vehicles = vehicles.filter((v) => {
          return v.itemId !== vehicle.itemId
        })
        vehicles.push(vehicle)
      } else {
        vehicles.push(vehicle)
      }
      sessionStorage.setItem('visited-vehicles-anonymous', JSON.stringify(vehicles))

      commit('add_visited_vehicle', vehicle)
    }
  },
  getVisitedVehicles({ commit }, userId) {
    const anonymousVisists = JSON.parse(sessionStorage.getItem('visited-vehicles-anonymous'))
    const visits = (userId !== null) ? _.union(JSON.parse(localStorage.getItem(`visited-vehicles-${userId}`)), anonymousVisists) : anonymousVisists

    if (visits !== null) {
      commit('add_visited_vehicle', visits)
    }
  },
  resetVisitedVehicles({ commit }) {
    commit('reset_visited_vehicles')
  }
}

const getters = {
  favoriteVehicles: state => {
    if (state.favoriteVehicles === null) {
      return state.favoriteVehicles
    }

    return state.favoriteVehicles
  },
  isFavoriteVehicle: state => (id) => {
    if (state.favoriteVehicles === null) {
      return false
    }

    return state.favoriteVehicles.filter((item) => {
      return item.itemId === id
    }).length > 0
  },
  visitedVehicles: state => {
    if (state.visitedVehicles === null) {
      return state.visitedVehicles
    }

    return state.visitedVehicles
  },
  isVehicleLatestVisit: state => (id) => {
    if (state.visitedVehicles === null) {
      return false
    }

    return state.visitedVehicles.findIndex(item => item.itemId === id) === state.visitedVehicles.length - 1
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
